import { Injectable } from '@angular/core';
import { Trade } from '../_models/trade';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

const baseUrl = `${environment.apiUrl}/bank`;
@Injectable({
  providedIn: 'root'
})
export class BankService {

  constructor(private http: HttpClient) { }

  registerBank(payload:any,file:any){
    const formData = new FormData();
    formData.append('bankname', payload.bankname);
    formData.append("address",payload.address);
    formData.append("country",payload.country);   
    formData.append('zipcode', payload.zipcode);
    formData.append("phonenumber",payload.phonenumber);
    formData.append("licencenumber",payload.licencenumber);   
    formData.append("permittedactivities",payload.permittedactivities);  
    formData.append("callbackurl",payload.callbackurl);
    formData.append("financingcallbackurl",payload.financingcallbackurl);
    formData.append("authHeader",payload.authHeader);
    formData.append("file",file);  
    return this.http.post(`${baseUrl}/register`,formData)
  }

  getAllBanks() {
    return this.http.get<any[]>(`${baseUrl}/all-bank`);
  }

  getBankDetails(bankId:any){
    return this.http.post(`${baseUrl}/get-bank`,{bankId :bankId })
  }
  updateBankDetails(bankId:any){
    return this.http.post(`${baseUrl}/get-bank`,{bankId :bankId })
  }
  update(id, params) {
    return this.http.put(`${baseUrl}/updatebank/${id}`, params)
        .pipe(map((account: any) => {
            return account;
        }));
}

}
